import { BaseClass } from './base';

export class AutoScalingGroupStartedActionProperties {
  constructor(props) {
    this.actionStatus = '';
    this.actionType = '';
    this.targetReplicaCount = 0;

    if (props) {
      Object.assign(this, props);
    }
  }
}

export class AutoScalingGroupStartedAction extends BaseClass {
  constructor(props) {
    super(props);

    this.properties = new AutoScalingGroupStartedActionProperties();

    if (props) {
      Object.assign(this, props);
    }
  }
}

export class AutoScalingGroupPolicy {
  constructor(props) {
    this.metric = '';
    this.scaleInAction = {
      amount: 0,
      amountType: '',
      cooldownPeriod: '',
    };
    this.scaleInThreshold = 0;
    this.scaleOutAction = {
      amount: 0,
      amountType: '',
      cooldownPeriod: '',
    };
    this.scaleOutThreshold = 0;
    this.policyRange = '';
    this.policyUnit = '';

    if (props) {
      Object.assign(this, props);
    }
  }
}

export class AutoScalingReplicaConfiguration {
  constructor(props) {
    this.cores = 1;
    this.ram = 1024;
    this.availabilityZone = 'AUTO';
    this.cpuFamily = '';
    this.location = '';

    this.nics = []; // { lan: 0, name: '' }
    this.volumes = [];

    if (props) {
      Object.assign(this, props);
    }
  }
}

export class AutoScalingGroupProperties {
  constructor(props) {
    this.name = '';
    this.datacenter = {
      id: '',
    };
    this.targetReplicaCount = 0;
    this.maxReplicaCount = 0;
    this.minReplicaCount = 0;
    this.policy = new AutoScalingGroupPolicy();
    this.replicaConfiguration = new AutoScalingReplicaConfiguration();

    if (props) {
      Object.assign(this, props);
    }
  }
}

export class AutoScalingGroup extends BaseClass {
  constructor(props) {
    super(props);

    this.properties = new AutoScalingGroupProperties();
    this.startedActions = [];

    if (props) {
      Object.assign(this, props);
    }
  }
}
